import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'
import { api } from '../../utils'

export default function ClientCreationCreate() {
  const history = useHistory()
  const [nome, setNome] = useState('')
  const [error, setError] = useState('')
  const [exactMatch, setExactMatch] = useState(null)
  const [similarMatches, setSimilarMatches] = useState([])

  const submit = async (confirmSimilar = false) => {
    try {
      setError('')
      const response = await api.post('clienti/client-creation/', {
        nome,
        confirm_similar: confirmSimilar,
      })

      if (response.data.outcome === 'exact_match') {
        setExactMatch(response.data.existing_cliente)
        setSimilarMatches([])
        return
      }

      if (response.data.outcome === 'similar_matches') {
        setExactMatch(null)
        setSimilarMatches(response.data.similar_matches || [])
        return
      }

      if (response.data.outcome === 'created') {
        history.push('/client-creation/clienti')
      }
    } catch (err) {
      setError(err?.response?.data?.nome?.[0] || 'Impossibile creare il cliente.')
    }
  }

  return (
    <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <div className="container-fluid">
        <Row>
          <Col lg="8">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Crea Cliente</h3>
                <Link to="/client-creation/clienti">Vai alla lista clienti</Link>
              </CardHeader>
              <CardBody>
                <FormGroup>
                  <Label for="client-creation-name">Nome Cliente</Label>
                  <Input
                    id="client-creation-name"
                    value={nome}
                    onChange={(event) => setNome(event.target.value)}
                  />
                </FormGroup>

                {error ? (
                  <Alert color="danger" fade={false}>
                    {error}
                  </Alert>
                ) : null}

                {exactMatch ? (
                  <Alert color="warning" fade={false}>
                    <p className="mb-1">Esiste già un cliente con questo nome.</p>
                    <strong>{exactMatch.nome}</strong>
                  </Alert>
                ) : null}

                {similarMatches.length > 0 ? (
                  <Alert color="warning" fade={false}>
                    <p className="mb-2">Abbiamo trovato clienti simili.</p>
                    <ul className="mb-3">
                      {similarMatches.map((cliente) => (
                        <li key={cliente.id}>{cliente.nome}</li>
                      ))}
                    </ul>
                    <Button color="warning" onClick={() => submit(true)}>
                      Crea comunque
                    </Button>
                  </Alert>
                ) : null}

                <Button color="primary" onClick={() => submit(false)}>
                  Crea cliente
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
